<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer002">
<h1 class="Prelims-head" lang="en-GB">the Author</h1>
<p class="Prelims-main" lang="en-GB"><img alt="" class="_idGenObjectAttribute-1" src="image/CLOUD-about-author-photo.jpg"/></p>
<p class="Prelims-main" lang="en-GB">Sophie Cloud is a poet and writer of historical fiction.<em class="italic" lang="en-GB"> It’s Murder!</em> is Sophie’s fourth book to be published. She resides in London with her family.<a id="_idTextAnchor000"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398432048_EPUB.vue?5e0e2d72